module.exports = function() {
  return new Worker(__webpack_public_path__ + "bab420e57839cc126632.worker.js");
};